<template>
  <v-container>
    <v-layout row justify-center>
      <v-flex xs12 md6 lg4 justify-center>
          <v-text-field
            label="E-mail"
            type="email"
            name="email"
            :rules="emailRules"
            validate-on-blur
            placeholder=""
            v-model="email"
          />
          <br>
          <v-text-field
            :label="$t('password')"
            type="password"
            name="password"
            placeholder=""
            v-model="password"
            :rules="PasswordRules"
            validate-on-blur
          />
          <v-btn type="submit" @click="login">{{ $t('login') }}</v-btn>
          <br>
          <br>
          <h3 v-if="error" class="text-xs-center">{{ error }}</h3>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '../services/AuthenticationService'
import Raygun from '../services/Raygun'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      error: null,
      emailRules: [
        v => !!v || this.$t('something_required', { something: 'E-mail' }),
        v =>
          /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t('something_not_valid', { something: 'E-mail' })
      ],
      PasswordRules: [
        v => !!v || this.$t('password_required'),
        v => v.length > 7 || this.$t('password_requirements', { length: 8, numbers: 1 })
      ]
    }
  },

  beforeCreate () {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.replace('/login')
    } else {
      if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) {
        this.$router.push('/telemarketing')
        return
      }
      this.$router.push('/transactions')
    }
  },

  created () {
    AuthenticationService.clearLoginState()
  },

  methods: {
    async login () {
      try {
        const loginResponse = await AuthenticationService.login({
          email: this.email,
          password: this.password
        })

        if (AuthenticationService.isRoleEmpty() && loginResponse !== 'newPasswordRequired') {
          this.error = 'User has no roles assigned'
          Raygun.send({message: this.error})
          return
        }
        this.addUserEmailToStorage()
        if (loginResponse === 'newPasswordRequired') {
          this.error = null
          this.$router.push('/completeregistration')
          return
        } else {
          let isTwoFAEnabled = localStorage.getItem('isTwoFAEnabled')
          if (isTwoFAEnabled === 'true') {
            this.$router.push('/confirmPin')
            return
          } else {
            if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) {
              this.$router.push('/telemarketing')
              return
            }
            this.$router.push('/transactions')
          }
        }
      } catch (error) {
        this.error = error.message
        Raygun.send(error)
      }
    },

    addUserEmailToStorage () {
      this.$store.commit('setUserEmail', {email: this.email})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue